export const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('@/pages/App'),
    props: true,
    children: [
      {
        name: 'list',
        path: '',
        components: {
          header: () => import('@/components/AppHeader'),
          default: () => import('@/pages/Home'),
          footer: () => import('@/components/AppFooter')
        }
      },
      {
        name: 'case.embed',
        path: '/:url_case/embed',
        props: true,
        component: () => import('@/pages/Embed')
      },
      {
        name: 'case.page',
        path: '/:url_case',
        props: true,
        components: {
          default: () => import('@/pages/Home'),
          footer: () => import('@/components/AppFooter')
        }
      }
    ]
  },
]

export default routes
